<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  <sc-file-download [fileInfo]="cellData"
                    [download$]="downloadFileExpr(rowData)">
  </sc-file-download>
</ng-template>